import { Injectable } from '@angular/core';

@Injectable()
export class CommonService {

  constructor() { }

  currentConsumptionResponse: any = [
    {
      message: "success",
      count: 1,
      data: [
        {
          "registerId": "1-0:1.8.0*255",
          "unit": "kWh",
          "value": {
            "measuredAt": "2023-10-10T18:30:00Z",
            "statusWord": 0,
            "value": 38.425,
            "receivedAt": "2023-10-10T19:01:13.768690Z",
            "readingReason": 1
          }
        },
      ]
    }
  ];

  pastSevenDays: any = {
    "registerId": "1-0:1.8.0*255",
    "unit": "kWh",
    "values": [
      {
        "measuredAt": "2023-10-04T04:41:33Z",
        "statusWord": 0,
        "value": 18.198,
        "receivedAt": "2023-10-04T04:43:12.850698Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T08:39:48Z",
        "statusWord": 0,
        "value": 18.546,
        "receivedAt": "2023-10-04T08:40:05.877428Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T15:40:14Z",
        "statusWord": 0,
        "value": 19.224,
        "receivedAt": "2023-10-04T15:39:52.354052Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T20:40:17Z",
        "statusWord": 0,
        "value": 19.752,
        "receivedAt": "2023-10-04T20:39:55.508216Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T03:40:26Z",
        "statusWord": 0,
        "value": 20.552,
        "receivedAt": "2023-10-05T03:40:05.339889Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T08:40:58Z",
        "statusWord": 0,
        "value": 21.064,
        "receivedAt": "2023-10-05T08:40:38.016847Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T17:41:49Z",
        "statusWord": 0,
        "value": 22.06,
        "receivedAt": "2023-10-05T17:47:43.447575Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T22:41:15Z",
        "statusWord": 0,
        "value": 22.801,
        "receivedAt": "2023-10-05T22:40:55.356107Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T02:40:08Z",
        "statusWord": 0,
        "value": 23.231,
        "receivedAt": "2023-10-06T02:40:01.005404Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T15:40:50Z",
        "statusWord": 0,
        "value": 24.436,
        "receivedAt": "2023-10-06T15:42:08.862808Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T20:39:49Z",
        "statusWord": 0,
        "value": 25.25,
        "receivedAt": "2023-10-06T20:39:56.263356Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T03:40:35Z",
        "statusWord": 0,
        "value": 26.133,
        "receivedAt": "2023-10-07T03:40:14.596880Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T11:41:46Z",
        "statusWord": 0,
        "value": 27.082,
        "receivedAt": "2023-10-07T11:41:37.887015Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T15:40:17Z",
        "statusWord": 0,
        "value": 27.576,
        "receivedAt": "2023-10-07T15:42:00.875656Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T20:39:47Z",
        "statusWord": 0,
        "value": 28.45,
        "receivedAt": "2023-10-07T20:39:27.780801Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T09:40:35Z",
        "statusWord": 0,
        "value": 30.335,
        "receivedAt": "2023-10-08T09:41:35.554930Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T14:40:06Z",
        "statusWord": 0,
        "value": 31.032,
        "receivedAt": "2023-10-08T14:39:47.642585Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T20:40:12Z",
        "statusWord": 0,
        "value": 31.906,
        "receivedAt": "2023-10-08T20:39:53.491606Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T02:40:55Z",
        "statusWord": 0,
        "value": 32.687,
        "receivedAt": "2023-10-09T02:42:14.245795Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T15:40:50Z",
        "statusWord": 0,
        "value": 34.514,
        "receivedAt": "2023-10-09T15:46:38.108123Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T20:40:13Z",
        "statusWord": 0,
        "value": 35.449,
        "receivedAt": "2023-10-09T20:44:04.120880Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-10T08:40:10Z",
        "statusWord": 0,
        "value": 36.963,
        "receivedAt": "2023-10-10T08:39:53.228286Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-10T17:41:45Z",
        "statusWord": 0,
        "value": 38.283,
        "receivedAt": "2023-10-10T17:43:15.042583Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T18:30:00Z",
        "statusWord": 0,
        "value": 19.538,
        "receivedAt": "2023-10-04T18:54:28.402699Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T18:30:00Z",
        "statusWord": 0,
        "value": 22.203,
        "receivedAt": "2023-10-05T19:52:36.605326Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T18:30:00Z",
        "statusWord": 0,
        "value": 24.871,
        "receivedAt": "2023-10-07T18:37:09.208951Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T18:30:00Z",
        "statusWord": 0,
        "value": 28.075,
        "receivedAt": "2023-10-07T18:37:09.237733Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T18:30:00Z",
        "statusWord": 0,
        "value": 31.589,
        "receivedAt": "2023-10-08T18:57:58.015369Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T18:30:00Z",
        "statusWord": 0,
        "value": 35.059,
        "receivedAt": "2023-10-09T20:02:15.008885Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-10T18:30:00Z",
        "statusWord": 0,
        "value": 38.425,
        "receivedAt": "2023-10-10T19:01:13.768690Z",
        "readingReason": 1
      }
    ]
  }

  monthlyConsumption: any = {
    "registerId": "1-0:1.8.0*255",
    "unit": "kWh",
    "values": [
      {
        "measuredAt": "2023-09-28T11:42:16Z",
        "statusWord": 0,
        "value": 0.004,
        "receivedAt": "2023-09-28T11:44:00.921550Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-28T14:40:50Z",
        "statusWord": 0,
        "value": 0.346,
        "receivedAt": "2023-09-28T14:40:41.623154Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-28T21:42:05Z",
        "statusWord": 0,
        "value": 1.513,
        "receivedAt": "2023-09-28T21:41:38.470925Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-29T04:41:32Z",
        "statusWord": 0,
        "value": 2.602,
        "receivedAt": "2023-09-29T04:41:06.275387Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-29T09:40:57Z",
        "statusWord": 0,
        "value": 3.257,
        "receivedAt": "2023-09-29T09:40:31.432124Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-29T15:40:23Z",
        "statusWord": 0,
        "value": 4.032,
        "receivedAt": "2023-09-29T15:41:18.460609Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-29T21:40:34Z",
        "statusWord": 0,
        "value": 5.064,
        "receivedAt": "2023-09-29T21:40:08.778497Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-30T02:40:21Z",
        "statusWord": 0,
        "value": 5.911,
        "receivedAt": "2023-09-30T02:39:55.762586Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-30T17:42:13Z",
        "statusWord": 0,
        "value": 7.889,
        "receivedAt": "2023-09-30T17:43:32.341275Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-30T21:40:56Z",
        "statusWord": 0,
        "value": 8.552,
        "receivedAt": "2023-09-30T21:40:39.437616Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-01T04:41:04Z",
        "statusWord": 0,
        "value": 9.355,
        "receivedAt": "2023-10-01T04:40:39.797890Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-01T10:41:37Z",
        "statusWord": 0,
        "value": 10.037,
        "receivedAt": "2023-10-01T10:41:52.009161Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-02T09:40:30Z",
        "statusWord": 0,
        "value": 13.137,
        "receivedAt": "2023-10-02T09:40:13.005749Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-02T22:42:54Z",
        "statusWord": 0,
        "value": 14.796,
        "receivedAt": "2023-10-02T22:42:49.110362Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-03T05:41:13Z",
        "statusWord": 0,
        "value": 15.492,
        "receivedAt": "2023-10-03T05:40:50.168419Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-03T09:40:54Z",
        "statusWord": 0,
        "value": 15.853,
        "receivedAt": "2023-10-03T09:40:32.645655Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-03T17:41:55Z",
        "statusWord": 0,
        "value": 16.782,
        "receivedAt": "2023-10-03T17:41:32.888541Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-03T21:40:53Z",
        "statusWord": 0,
        "value": 17.304,
        "receivedAt": "2023-10-03T21:43:07.655814Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T04:41:33Z",
        "statusWord": 0,
        "value": 18.198,
        "receivedAt": "2023-10-04T04:43:12.850698Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T08:39:48Z",
        "statusWord": 0,
        "value": 18.546,
        "receivedAt": "2023-10-04T08:40:05.877428Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T15:40:14Z",
        "statusWord": 0,
        "value": 19.224,
        "receivedAt": "2023-10-04T15:39:52.354052Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T20:40:17Z",
        "statusWord": 0,
        "value": 19.752,
        "receivedAt": "2023-10-04T20:39:55.508216Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T03:40:26Z",
        "statusWord": 0,
        "value": 20.552,
        "receivedAt": "2023-10-05T03:40:05.339889Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T08:40:58Z",
        "statusWord": 0,
        "value": 21.064,
        "receivedAt": "2023-10-05T08:40:38.016847Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T17:41:49Z",
        "statusWord": 0,
        "value": 22.06,
        "receivedAt": "2023-10-05T17:47:43.447575Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T22:41:15Z",
        "statusWord": 0,
        "value": 22.801,
        "receivedAt": "2023-10-05T22:40:55.356107Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T02:40:08Z",
        "statusWord": 0,
        "value": 23.231,
        "receivedAt": "2023-10-06T02:40:01.005404Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T15:40:50Z",
        "statusWord": 0,
        "value": 24.436,
        "receivedAt": "2023-10-06T15:42:08.862808Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T20:39:49Z",
        "statusWord": 0,
        "value": 25.25,
        "receivedAt": "2023-10-06T20:39:56.263356Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T03:40:35Z",
        "statusWord": 0,
        "value": 26.133,
        "receivedAt": "2023-10-07T03:40:14.596880Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T11:41:46Z",
        "statusWord": 0,
        "value": 27.082,
        "receivedAt": "2023-10-07T11:41:37.887015Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T15:40:17Z",
        "statusWord": 0,
        "value": 27.576,
        "receivedAt": "2023-10-07T15:42:00.875656Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T20:39:47Z",
        "statusWord": 0,
        "value": 28.45,
        "receivedAt": "2023-10-07T20:39:27.780801Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T09:40:35Z",
        "statusWord": 0,
        "value": 30.335,
        "receivedAt": "2023-10-08T09:41:35.554930Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T14:40:06Z",
        "statusWord": 0,
        "value": 31.032,
        "receivedAt": "2023-10-08T14:39:47.642585Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T20:40:12Z",
        "statusWord": 0,
        "value": 31.906,
        "receivedAt": "2023-10-08T20:39:53.491606Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T02:40:55Z",
        "statusWord": 0,
        "value": 32.687,
        "receivedAt": "2023-10-09T02:42:14.245795Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T15:40:50Z",
        "statusWord": 0,
        "value": 34.514,
        "receivedAt": "2023-10-09T15:46:38.108123Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T20:40:13Z",
        "statusWord": 0,
        "value": 35.449,
        "receivedAt": "2023-10-09T20:44:04.120880Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-10T08:40:10Z",
        "statusWord": 0,
        "value": 36.963,
        "receivedAt": "2023-10-10T08:39:53.228286Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-10T17:41:45Z",
        "statusWord": 0,
        "value": 38.283,
        "receivedAt": "2023-10-10T17:43:15.042583Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-11T02:40:06Z",
        "statusWord": 0,
        "value": 39.827,
        "receivedAt": "2023-10-11T02:39:49.955121Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-11T10:41:16Z",
        "statusWord": 0,
        "value": 40.909,
        "receivedAt": "2023-10-11T10:43:10.615677Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-11T14:40:45Z",
        "statusWord": 0,
        "value": 41.485,
        "receivedAt": "2023-10-11T14:43:29.647897Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-11T20:39:51Z",
        "statusWord": 0,
        "value": 42.478,
        "receivedAt": "2023-10-11T20:42:21.006391Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-12T04:40:30Z",
        "statusWord": 0,
        "value": 43.538,
        "receivedAt": "2023-10-12T04:40:49.739798Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-12T08:40:48Z",
        "statusWord": 0,
        "value": 44.048,
        "receivedAt": "2023-10-12T08:42:55.625732Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-15T18:30:00Z",
        "statusWord": 0,
        "value": 0,
        "receivedAt": "2023-09-28T20:03:19.493876Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-28T18:30:00Z",
        "statusWord": 0,
        "value": 0.989,
        "receivedAt": "2023-09-28T20:03:19.535711Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-29T18:30:00Z",
        "statusWord": 0,
        "value": 4.508,
        "receivedAt": "2023-09-29T18:57:54.055239Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-30T18:30:00Z",
        "statusWord": 0,
        "value": 8.042,
        "receivedAt": "2023-09-30T18:54:00.471912Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-01T18:30:00Z",
        "statusWord": 0,
        "value": 11.102,
        "receivedAt": "2023-10-01T18:45:10.070920Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-02T18:30:00Z",
        "statusWord": 0,
        "value": 14.194,
        "receivedAt": "2023-10-02T18:45:52.307318Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-03T18:30:00Z",
        "statusWord": 0,
        "value": 16.872,
        "receivedAt": "2023-10-03T21:03:41.072429Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-04T18:30:00Z",
        "statusWord": 0,
        "value": 19.538,
        "receivedAt": "2023-10-04T18:54:28.402699Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-05T18:30:00Z",
        "statusWord": 0,
        "value": 22.203,
        "receivedAt": "2023-10-05T19:52:36.605326Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-06T18:30:00Z",
        "statusWord": 0,
        "value": 24.871,
        "receivedAt": "2023-10-07T18:37:09.208951Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-07T18:30:00Z",
        "statusWord": 0,
        "value": 28.075,
        "receivedAt": "2023-10-07T18:37:09.237733Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-08T18:30:00Z",
        "statusWord": 0,
        "value": 31.589,
        "receivedAt": "2023-10-08T18:57:58.015369Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-09T18:30:00Z",
        "statusWord": 0,
        "value": 35.059,
        "receivedAt": "2023-10-09T20:02:15.008885Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-10T18:30:00Z",
        "statusWord": 0,
        "value": 38.425,
        "receivedAt": "2023-10-10T19:01:13.768690Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-10-11T18:30:00Z",
        "statusWord": 0,
        "value": 42.117,
        "receivedAt": "2023-10-11T20:53:00.370863Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-08-29T11:59:55Z",
        "statusWord": 0,
        "value": 0,
        "receivedAt": "2023-09-28T22:45:39.528404Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-08-29T13:57:52Z",
        "statusWord": 0,
        "value": 0,
        "receivedAt": "2023-09-28T22:45:39.553688Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-15T03:33:47Z",
        "statusWord": 0,
        "value": 0,
        "receivedAt": "2023-09-28T22:45:39.578615Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-15T03:34:53Z",
        "statusWord": 0,
        "value": 0,
        "receivedAt": "2023-09-28T22:45:39.600650Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-08-31T18:30:00Z",
        "statusWord": 0,
        "value": 0,
        "receivedAt": "2023-09-30T19:37:24.442338Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-30T18:30:00Z",
        "statusWord": 0,
        "value": 8.042,
        "receivedAt": "2023-09-30T19:37:24.466582Z",
        "readingReason": 1
      },
      {
        "measuredAt": "2023-09-30T19:37:35Z",
        "statusWord": 0,
        "value": 8.242,
        "receivedAt": "2023-09-30T19:37:24.466582Z",
        "readingReason": 1
      }
    ]
  }


  getCurrentConsumption() {
    return this.currentConsumptionResponse;
  }

  getPastSevenDaysCons() {
    return this.pastSevenDays;
  }

  getMonthlyConsumption() {
    return this.monthlyConsumption;
  }

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/common/common.service.ts